module.exports = __webpack_public_path__ + "static/img/tabela.92edebd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/uva/tabela.png
// module id = YI+Q
// module chunks = 0